import Image from "@tiptap/extension-image";

const SizableImage = Image.extend({
  name: "SizableImage",
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: "25%",
        renderHTML: (attributes) => {
          return {
            width: attributes.width,
          };
        },
      },
    };
  },
  addCommands() {
    return {
      ...this.parent?.(),
      small:
        () =>
        ({ commands }) => {
          commands.updateAttributes("SizableImage", { width: "25%" });
        },
      medium:
        () =>
        ({ commands }) => {
          commands.updateAttributes("SizableImage", { width: "50%" });
        },
      large:
        () =>
        ({ commands }) => {
          commands.updateAttributes("SizableImage", { width: "75%" });
        },
    };
  },
});

export default SizableImage;
